import React from 'react';
import Row from 'chameleon/ui-stack/ui/base/table/Row';
import cn from 'classnames';
import { useDraggable } from '@dnd-kit/core';

import { useTeacherOrganizeContext } from 'legacy-src/components/TeacherOrganize/hooks/useTeacherOrganize';
import { resourceTypes } from 'chameleon/legacy/src/components/TeacherOrganize/utils/constants';

const AssessmentsTableRow = ({
  row,
  className,
  onClick,
  children,
  labelsDnDFF,
  ...props
}) => {
  const labels = row?.original?.labels || [];

  const {
    state: { isBulkMode },
  } = useTeacherOrganizeContext({});

  const isDraggingDisabled =
    !labelsDnDFF || isBulkMode || row.original.type === resourceTypes.pdf;
  const { isDragging, listeners, setNodeRef } = useDraggable({
    id: `assessment/${props.rowId}`,
    data: {
      id: row.original.id,
      title: row.original.title,
      type: row.original.type,
    },
    disabled: isDraggingDisabled,
  });

  return (
    <Row
      a11yIgnoreEvents
      ref={setNodeRef}
      row={row}
      onClick={onClick}
      className={cn(
        'assignments-table-row items-center justify-between py-4 mobile:relative',
        className,
        { 'align-top': labels.length > 1 },
        { 'bg-blue-100': isDragging },
      )}
      data-drag-element
      {...listeners}
      {...props}
    >
      {children}
    </Row>
  );
};

export default AssessmentsTableRow;
